// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NicheChartSelector {
  padding: 24px;
  border: 1px solid var(--color_neutral_400);
  border-radius: 16px;
}
.NicheChartSelector .NicheChartSelector-titleRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.NicheChartSelector .NicheChartSelector-titleRow h3 {
  color: var(--color_neutral_900);
  font-size: 24px;
  font-weight: 600;
}
.NicheChartSelector .NicheChartSelector-chartActions {
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
}
.NicheChartSelector .NicheChartSelector-chartTypeSelector {
  border: 1px solid var(--color_neutral_400);
  border-radius: 6px;
  padding: 6px 12px;
  display: flex;
  flex-direction: row;
  column-gap: 8px;
}
.NicheChartSelector .NicheChartSelector-chartTypeSelector .NicheChartSelector-chartButton {
  padding: 0px;
  margin: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.NicheChartSelector .NicheChartSelector-chartTypeSelector .NicheChartSelector-chartButton:hover, .NicheChartSelector .NicheChartSelector-chartTypeSelector .NicheChartSelector-chartButton.isActive {
  background-color: var(--color_neutral_200);
  border-radius: 6px;
}
.NicheChartSelector .NicheChartSelector-chartTypeSelector .NicheChartSelector-chartButton:disabled {
  background-color: transparent;
  cursor: not-allowed;
}
.NicheChartSelector .NicheChartSelector-chartTypeSelector .NicheChartSelector-chartButton:disabled svg {
  color: var(--color_neutral_400) !important;
}
.NicheChartSelector .NicheChartSelector-chartContent {
  height: 500px;
}`, "",{"version":3,"sources":["webpack://./src/modules/niche/niche-chart-selector/niche-chart-selector.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AACJ;AACI;EACE,+BAAA;EACA,eAAA;EACA,gBAAA;AACN;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,0CAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAFJ;AAII;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAIM;EAEE,0CAAA;EACA,kBAAA;AAHR;AAMM;EACE,6BAAA;EACA,mBAAA;AAJR;AAMQ;EACE,0CAAA;AAJV;AAUE;EACE,aAAA;AARJ","sourcesContent":[".NicheChartSelector {\n  padding: 24px;\n  border: 1px solid var(--color_neutral_400);\n  border-radius: 16px;\n\n  .NicheChartSelector-titleRow {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 24px;\n\n    h3 {\n      color: var(--color_neutral_900);\n      font-size: 24px;\n      font-weight: 600;\n    }\n  }\n\n  .NicheChartSelector-chartActions {\n    display: flex;\n    flex-direction: row;\n    column-gap: 16px;\n    align-items: center;\n  }\n\n  .NicheChartSelector-chartTypeSelector {\n    border: 1px solid var(--color_neutral_400);\n    border-radius: 6px;\n    padding: 6px 12px;\n    display: flex;\n    flex-direction: row;\n    column-gap: 8px;\n\n    .NicheChartSelector-chartButton {\n      padding: 0px;\n      margin: 0px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n\n      &:hover,\n      &.isActive {\n        background-color: var(--color_neutral_200);\n        border-radius: 6px;\n      }\n\n      &:disabled {\n        background-color: transparent;\n        cursor: not-allowed;\n\n        svg {\n          color: var(--color_neutral_400) !important;\n        }\n      }\n    }\n  }\n\n  .NicheChartSelector-chartContent {\n    height: 500px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
